import React from 'react';
import Landing from '../../components/LandingPage/Landing';
import Payment from '../../components/payment-section/Payment';
const LandingPage = () => {
    return (
        <div>
            <Landing />
        </div>
    );
}

export default LandingPage;
